export default __webpack_public_path__ + "static/media/homeCover.d21d29a4.jpg";